<div class="overview">
	<div class="tasks">
		<div class="overview-header">
			<H2>{{ controller.payment.title }}</H2>
			<span class="overview-sub-header"> {{ controller.payment.description }}</span>
		</div>
		<div>
			<div class="line-item">
				<a class="complete-all" (click)="completeAll()">Complete All</a>
			</div>
			@for (task of controller.payment.items; track task) {
				<div class="line-item">
					<div>{{ task.label }}</div>
					<mat-checkbox [(ngModel)]="taskValues[controller.payment.id +'.'+task.id]"
					              (ngModelChange)="setValue(controller.payment.id,task.id,$event)"></mat-checkbox>
				</div>
			}
		</div>
	</div>
</div>
